import { z } from "zod";
import { UserResponseSchema } from "./user";
import { PermissionResponseSchema } from "./roles-permissions";

// Login
export const LoginRequestSchema = z.object({
  email: z.email("Email inválido"),
  password: z.string().min(8, "La contraseña debe tener al menos 8 caracteres"),
});

export type LoginRequestDTO = z.infer<typeof LoginRequestSchema>;

export const LoginResponseSchema = z.object({
  user: UserResponseSchema,
  accessToken: z.string(),
  refreshToken: z.string(),
  expiresAt: z.coerce.date(),
  permissions: z.array(PermissionResponseSchema),
});

export type LoginResponseDTO = z.infer<typeof LoginResponseSchema>;

// Logout / Refresh (mismo schema, solo necesita refreshToken)
export const LogoutRequestSchema = z.object({
  refreshToken: z.string(),
});

export type LogoutRequestDTO = z.infer<typeof LogoutRequestSchema>;

// Alias para Refresh (usa el mismo schema que Logout)
export const RefreshRequestSchema = LogoutRequestSchema;
export type RefreshRequestDTO = LogoutRequestDTO;

// Forgot Password
export const ForgotPasswordRequestSchema = z.object({
  email: z.string().email("Email inválido"),
});
export type ForgotPasswordRequestDTO = z.infer<typeof ForgotPasswordRequestSchema>;

// Reset Password
export const ResetPasswordRequestSchema = z.object({
  token: z.string(),
  newPassword: z.string().min(8, "La contraseña debe tener al menos 8 caracteres"),
});
export type ResetPasswordRequestDTO = z.infer<typeof ResetPasswordRequestSchema>;
